import {
  productImageGalleryKeenBlueprint,
  productViennaTemplateBlueprint,
  productDetailsBlueprint,
  addToCartButtonBlueprint,
  uspBlockBlueprint,
  siblingsImageCardBlueprint,
  sizePickerModalBlueprint,
  productAttributesRowBlueprint,
  siblingsColorSwatchBlueprint,
  relatedProductsImageCardsBlueprint,
  stickyAddToCartButtonBlueprint,
} from "@made-people/blueprint-product/blueprint";

// Root grid styling
productViennaTemplateBlueprint.override({
  slots: {
    base: "flex flex-col md:grid md:grid-cols-12 md:px-6 lg:max-w-component-max-w-xl px-4 xl:px-0 lg:mx-auto mb-8",
    breadcrumbsWrapper: "col-span-6 lg:col-span-12 py-2 lg:py-6",
    detailsWrapper:
      "lg:row-start-2 col-start-8 col-span-5 text-left lg:sticky top-32 left-0 bg-background-page lg:h-fit lg:pb-4",
    relatedProductsWrapper: "col-span-12",
    productVideo: "col-start-1 col-span-6 my-2 lg:row-start-8",
    attributesWrapper:
      "text-body-md lg:row-start-5 col-start-1 col-span-6 my-2 flex flex-col gap-1",
    highlightTextWrapper:
      "text-body-md lg:row-start-4 col-start-1 col-span-6 my-2 flex flex-col pl-4",
    highlightTextRow: "empty:hidden list-disc",
    badgesWrapper: "flex absolute top-3 left-3 z-10 gap-2",
    reviewCarouselWrapper: "rounded-md",
  },
});

stickyAddToCartButtonBlueprint.override({
  slots: {
    base: "fixed data-[is-visible=true]:bottom-0 -bottom-16 left-0 right-0 w-full data-[is-visible=true]:bg-white/70 data-[is-visible=false]:bg-transparent data-[is-visible=true]:backdrop-blur-sm data-[is-visible=true]:border-t data-[is-visible=true]:border-gray-200/30 lg:hidden z-[45] transition-all duration-[500ms] ease-[linear(0,_0.012_0.9%,_0.049_2%,_0.409_9.3%,_0.513_11.9%,_0.606_14.7%,_0.691_17.9%,_0.762_21.3%,_0.82_25%,_0.868_29.1%,_0.907_33.6%,_0.937_38.7%,_0.976_51.3%,_0.994_68.8%,_1)] p-4",
    buttonsWrapper: "grid grid-cols-2 gap-2 w-full",
  },
});

relatedProductsImageCardsBlueprint.override({
  slots: {
    base: "flex flex-col gap-4 lg:row-start-7 col-start-1 col-span-6 my-4 lg:my-6",
    heading: "text-heading-lg font-secondary",
    wrapper:
      "grid grid-cols-2 gap-4 md:grid-cols-3 lg:gap-4 [&>div]:flex-1 [&>div]:min-w-[140px] [&>div]:w-full justify-items-start auto-rows-fr",
  },
});

siblingsColorSwatchBlueprint.override({
  slots: {
    base: "col-span-3 flex flex-col gap-3 mt-4 mb-6 lg:my-8",
    header: "text-theme-label-sm flex justify-between items-center",
    siblingsWrapper: "flex gap-3 flex-wrap lg:gap-4",
    sibling:
      "w-8 h-8 rounded-full data-[is-selected=true]:!outline-black/80 hover:outline-black/50 outline outline-2 outline-transparent data-[is-selected=true]:border-white border-[3px] border-background-page transition-colors data-[is-white=true]:outline-black/10",
  },
});

productAttributesRowBlueprint.override({
  slots: {
    base: "block text-body-md",
    label: "font-bold inline mr-1",
    value: "inline",
  },
});

// Image gallery styling mobile
productImageGalleryKeenBlueprint.override({
  slots: {
    base: "w-full md:col-span-7 md:pr-14 mb-6 lg:mb-0 lg:aspect-[15/14] group/keen [--keen-slider-spacing:0px] [--keen-slider-per-view:1] md:[--keen-slider-per-view:1.3] lg:[--keen-slider-per-view:1.5]",
    galleryWrapper:
      "flex overflow-hidden relative aspect-product-image lg:aspect-[15/14] h-full",
    imageWrapper:
      "aspect-product-image bg-[#F6F6F6] group-data-[button-in-slider=true]/keen:pb-12 w-[calc((100%-((var(--keen-slider-per-view)-1)*var(--keen-slider-spacing)))/var(--keen-slider-per-view))] shrink-0 overflow-hidden",
    image:
      "aspect-product-image h-full w-full object-cover cursor-grab active:cursor-grabbing",
    peekingImage: "opacity-50 absolute inset-0 bg-background-page",
    thumbnailWrapper: "!hidden",
    dotsIndicatorWrapper: "hidden",
    dotsIndicator: "",
    linkButton:
      "h-12 absolute bottom-0 left-0 right-0 bg-beige-600 hover:bg-beige-400 transition-colors text-white text-center",
    arrowsWrapper: "flex justify-between absolute top-1/2 left-2 right-2",
    leftArrow:
      "p-4 fill-black rounded-full bg-white border border-border-light",
    rightArrow:
      "p-4 fill-black rounded-full bg-white border border-border-light",
  },
});

// Usp block from market settings styling
uspBlockBlueprint.override({
  slots: {
    base: "hidden lg:flex flex-col md:flex-row justify-between my-6",
    item: "flex gap-4 items-center h-[40px] [&>img]:h-[40px]",
    label: "text-label-md font-bold uppercase",
  },
});

// Size picker modal styling
sizePickerModalBlueprint.override({
  slots: {
    trigger: "w-full max-w-[200px]",
    optionsWrapper: "flex flex-col-reverse gap-4 mt-4 mb-6 lg:mb-8",
    wrapper: "flex flex-col gap-4 max-w-[448px]",
    header: "text-left first:mt-4",
    heading: "text-heading-sm font-bold",
    sizeWrapper: "flex flex-row flex-wrap gap-3 w-full",
    size: "w-14 h-14 flex [&>div]:!px-0 items-center justify-center rounded-full border border-neutral-200 text-label-md text-neutral-600 transition-colors hover:border-neutral-400 data-[is-out-of-stock='true']:bg-out-of-stock-bg data-[is-out-of-stock='true']:border-out-of-stock-bg data-[is-out-of-stock='true']:text-out-of-stock-label data-[is-out-of-stock='true']:cursor-default data-[is-out-of-stock='true']:[--default-bg:theme(colors.out-of-stock.bg)] data-[is-out-of-stock='true']:[--disabled-bg:theme(colors.out-of-stock.bg)] data-[is-out-of-stock='true']:[--default-label:theme(colors.out-of-stock.label)] data-[is-out-of-stock='true']:[--disabled-label:theme(colors.out-of-stock.label)] data-[is-out-of-stock='true']:[--border:theme(colors.out-of-stock.bg)] data-[is-selected=true]:bg-black data-[is-selected=true]:text-white data-[is-selected=true]:border-black data-[is-selected=true]:[--active-bg:black] data-[is-selected=true]:[--active-label:white]",
  },
});

// Add to cart button styling
addToCartButtonBlueprint.override({
  slots: {
    base: "col-span-3 mt-4 gap-2 flex flex-col w-full",
  },
});

// Swatch picker styling
siblingsImageCardBlueprint.override({
  slots: {
    base: "col-span-3 flex flex-col gap-3 my-3",
    header: "text-label-md font-medium flex justify-between items-center",
    siblingsWrapper: "flex gap-2 flex-wrap",
    sibling:
      "flex justify-center rounded-[4px] overflow-hidden transition-colors data-[is-selected=true]:outline-body hover:outline-black/50 outline-offset-2 outline outline-1 outline-transparent",
    siblingImage: "w-12 aspect-product-image object-cover",
  },
});

// Product details styling
productDetailsBlueprint.main.override({
  slots: {
    priceWrapper: "flex flex-row gap-2 col-start-3 col-end-4 mt-3",
    oldPrice: "line-through text-sale-price text-heading-sm lg:text-heading-md",
    price: "text-heading-sm lg:text-heading-md",
    name: "col-start-1 col-end-3 text-heading-md lg:text-heading-lg lg:font-normal",
    shortDescription: "text-body-md col-span-3",
    description:
      "text-body-md lg:row-start-3 col-start-1 col-span-6 mb-6 mt-4 lg:my-6",
    descriptionReadMoreButton: "text-link text-body-sm mt-2 cursor-pointer",
    brand:
      "text-body-sm lg:text-body-md text-text-less-emphasis-1 lg:col-span-3 mb-3",
    productType:
      "uppercase text-body-sm lg:col-span-3 font-medium leading-none lg:leading-normal",
    accordionWrapper: "col-span-3 border-t border-gray-200",
  },
});
